<template>
  <v-card>
    <div class="pa-4">
      <h4>Network</h4>
    </div>
    <v-divider></v-divider>
    <v-tabs v-model="tab">
      <v-tab> Friends </v-tab>
      <v-tab> Joined Groups </v-tab>
      <v-tab> My Groups </v-tab>
      <v-tab> My Events </v-tab>
      <v-tab> Requests </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col
              v-for="(connect, key) of userConnects"
              :key="'networkFriends' + key"
              md="4"
              cols="12"
            >
              <UserCard :user="connect" :isFriend="true" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col v-for="g of joinedGroups" :key="g.id" md="4" cols="12">
              <GroupCard
                :item="g"
                
              />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <div class="d-flex">
            <v-btn
              class="ml-auto mb-4"
              small
              color="primary"
              @click="dialog = true"
              >Create Group</v-btn
            >
          </div>
          <v-row>
            <v-col v-for="g of groups" :key="g.id" md="4" cols="12">
              <GroupCard
                :item="g"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col v-for="(event, k) of postEvents" :key="k" md="4" cols="12">
              <event-card :event="event" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <v-row>
            <v-col v-for="(item, k) of requestedTo" class="border-bottom" :key="k" md="12" cols="12">
              <div class="d-flex align-center">
                <div class="profile-card">
                  <v-avatar v-if="item.requestByData.profile_image" class="mr-3"
                    ><img :src="item.requestByData.profile_image"
                  /></v-avatar>
                  <v-avatar v-else class="mr-3"
                    ><img src="/images/default-profile.jpg"
                  /></v-avatar>
                  <div class="profile-info ml-2">
                    <h5 class="name ma-0" v-if="item.requestByData">
                      {{ item.requestByData.firstname }}
                      {{ item.requestByData.lastname }}
                    </h5>
                    <small class="deignation d-block"
                      >@{{ item.requestByData.username }}</small
                    >
                    <v-chip x-small
                      >{{ item.requestByData.connects.length }} connects</v-chip
                    >
                  </div>
                </div>
                <span class="ml-auto">
                  <v-btn
                    small
                    color="primary"
                    @click="lc_accept_request(item.requested_by)"
                    >Accept</v-btn
                  >
                  <v-btn
                    small
                    color="red white--text"
                    class="ml-3"
                    @click="lc_reject_request(item.requested_by)"
                    >Reject</v-btn
                  >
                </span>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="dialog"
      width="500"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Create Group</v-toolbar-title>
        </v-toolbar>
        <div class="pa-4">
          <v-form ref="ref_create_group" @submit="lc_add_group">
            <v-text-field
              label="Group Title"
              outlined
              solo
              dense
              flat
              v-model="data.name"
              :rules="[myrules.required]"
            ></v-text-field>
            <v-autocomplete
              label="Group Members"
              :items="userConnects"
              class="mt-5"
              outlined
              solo
              dense
              flat
              item-text="name"
              item-value="id"
              multiple
              v-model="data.members"
              :rules="[myrules.required]"
            ></v-autocomplete>
            <v-autocomplete
              label="Group Type"
              class="mt-5"
              outlined
              solo
              dense
              flat
              :items="['Public', 'Private']"
              v-model="data.type"
              :rules="[myrules.required]"
            ></v-autocomplete>
            <v-textarea
              placeholder="Group Description"
              class="mt-5"
              outlined
              v-model="data.description"
              :rules="[myrules.required]"
              solo
              dense
              flat
            ></v-textarea>
            <div class="d-flex mt-3">
              <v-btn
                color="red"
                class="white--text ml-auto mr-3"
                @click="dialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" type="submit">Save</v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UserCard from "../components/network/UserCard.vue";
import GroupCard from "../components/network/GroupCard.vue";
import EventCard from "../components/EventCard.vue";
export default {
  name: "Network",
  components: {
    UserCard,
    GroupCard,
    EventCard,
  },
  data() {
    return {
      tab: null,
      dialog: null,
      data: {
        name: "",
        members: [],
        type: "",
        description: "",
      },
    };
  },
  mounted() {
    let id = this.authUser.id;
    this.getGroups(id);
    this.getJoinedGroups(id);
    this.getEvents(id);
    this.getRequestRecieved(id);
  },
  methods: {
    async lc_add_group(e) {
      e.preventDefault();
      let validate = this.$refs.ref_create_group.validate();
      if (validate) {
        let obj = {
          owner_id: this.authUser.id,
          ...this.data,
          members: [...this.data.members, this.authUser.id],
        };
        await this.addGroup({ ...obj });
        this.dialog = false;
        this.$refs.ref_create_group.reset();
      }
    },
    async lc_accept_request(id) {
      let obj = {
        requested_by: id,
        requested_to: this.authUser.id,
      };
      await this.acceptRequest(obj);
    },
    async lc_reject_request(id) {
      let obj = {
        requested_by: id,
        requested_to: this.authUser.id,
      };
      await this.rejectRequest(obj);
    },
  },
};
</script>

<style>
.profile-card {
  height: 80px;
  display: flex;
  align-items: center;
  line-height: 1.2;
}
.user-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.mutual-friends {
  position: relative;
  height: 25px;
}
.mutual-friend {
  border: 1px solid #fff;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
.mutual-friend:nth-child(1) {
  left: 5px;
  background: orange;
}
.mutual-friend:nth-child(2) {
  left: 10px;
  background: yellow;
}
.mutual-friend:nth-child(3) {
  left: 15px;
  background: red;
}
</style>